import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToOrganization,
  mapOrganizationUpdateToPayload,
  type Organization,
  type OrganizationApiResource,
  type OrganizationUpdate,
} from './organizationApi.types';

const ORGANIZATION_PATH = '/me/workspace/organization';

export async function fetchOrganization(): Promise<Organization> {
  const response = await httpClient.get<OrganizationApiResource>(ORGANIZATION_PATH);
  return mapApiResourceToOrganization(response.data);
}

export async function updateOrganization(update: OrganizationUpdate): Promise<Organization> {
  const response = await httpClient.patch<OrganizationApiResource>(
    ORGANIZATION_PATH,
    mapOrganizationUpdateToPayload(update)
  );
  return mapApiResourceToOrganization(response.data);
}
